import { BaseModel } from "@/models/base.model"
import { type IAvailabilityReason } from "@/interfaces/api/availability-reason.interface.ts"

export class AvailabilityReason extends BaseModel implements IAvailabilityReason {
  public static className = "AvailabilityReason" // Used for socket communication.
  public static verboseName = "beschikbaarheidsreden"

  entityTable: string
  label: string

  constructor(availabilityReason: IAvailabilityReason) {
    super(availabilityReason)

    this.entityTable = availabilityReason.entityTable
    this.label = availabilityReason.label
  }
}
